import React from 'react';
import { useState, useRef } from 'react';
import moment from 'moment';
import './edit.css'
import { useEffect } from 'react';
import { YEARS } from './Forms/constants';
import AchivementForm from './Forms/achievementForm';
import AwardForm from './Forms/awardForm';
import Pressform from './Forms/PressForm';
import { Col, Row } from 'react-bootstrap';
import { database } from "../firebase";
import { useSelector } from "react-redux";
import Loader from 'react-spinners/BarLoader';
import { object } from 'prop-types';
const { forwardRef, useImperativeHandle } = React;

const EditAchievements = forwardRef((props, ref) => {
    const [open, setopen] = useState(false)
    const [value, setValue] = useState()
    const [achivements, setAchivements] = useState([])
    const [loading, setLoading] = useState(false)
    const [checking, setCHecking] = useState([])
    const [category_check_list, setCategoryCheckList] = useState([]);
    const [active_check_list, setActiveCheckList] = useState([])
    const { currentUser } = useSelector((state) => ({
        currentUser: state.profile.currentUser,
    }));

    function handleClick() {
        if (open == false) {
            setopen(true)

        }
        else {
            setopen(false)
        }
    }

    function handleUpdate() {
        setValue()
        setLoading(true)
        getAchivements()
        setLoading(false)
    }

    const ShowForm = () => {

        if (value === 'Achievements') {

            return <AchivementForm handleupdate={handleUpdate} />

        }
        else if (value === 'Awards') {
            return <AwardForm handleupdate={handleUpdate} />
        }
        else if (value === 'Press') {
            return <Pressform handleupdate={handleUpdate} />
        }
    }

    const getAchivements = () => {
        let achivements = [];
        let achive = [];
        return database.ref('achievements/' + currentUser.uid).once("value")
            .then(async (snapshot) => {
              
                achive.push(snapshot.val())
                if(achive[0]){
                    achive.forEach(a => {
                        const newAchives = [];
                        const key = Object.keys(a).forEach(object => {
                            const pushkey = a[object]
                            newAchives.push({ ...pushkey, key: object })
                        })
                        setAchivements(newAchives)
                        const deletedAchivements = newAchives.map((achivement) => {
                            if (achivement.isDeleted == false) {
                                return { checked: true }
                            }
                            else {
                                return { checked: false }
                            }
    
                        })
                        setCHecking(deletedAchivements)
                    })
    
        
                }
                            }
            )
    }
    const categoryCheckboxFilterHandler = (e, i) => {
        if (checking[i].checked == true) {
            checking[i].checked = false
        }
        else {
            checking[i].checked = true
        }

        if (e.target.checked == false) {
            setCategoryCheckList([...category_check_list, e.target.value]);
        }

        else {
            let check_list = [];
            category_check_list.map(check => {
                if (check != e.target.value) {
                    check_list.push(check);
                }
            });
            setCategoryCheckList(check_list);
        }

        if (e.target.checked == true) {

            setActiveCheckList([...active_check_list, e.target.value]);


        }
        else {
            let check_list = [];
            active_check_list.map(check => {
                if (check != e.target.value) {
                    check_list.push(check);
                }
            });
            setActiveCheckList(check_list);

        }

    };

    useImperativeHandle(ref, () => ({
        handleUpdate() {
            let userRef = database.ref('achievements/' + currentUser.uid);
            category_check_list.map(async (check) => {
                await userRef.child(check).update({ 'isDeleted': true })

            }
            )

            active_check_list.map(async (check) => {
                await userRef.child(check).update({ 'isDeleted': false })

            }
            )

        }

    }));


    useEffect(() => {
        getAchivements()
    }, [currentUser])

    return (
        <>
            {loading === true ? <Loader /> :
                <div className="row align-items-center mb-1">
                    <div className="col-md-6 mb-3">
                        <label className="align-middle fw-medium mb-0">
                            <input className="form-check-input me-3" type="checkbox" defaultChecked />
                            Show/Hide on profile page
                        </label>
                    </div>
                    <div className="col-md-6 text-end mb-3">
                        <div className="container" style={{ width: '300px', marginLeft: 'auto' }}>
                            <div>
                                <button className="btn btn-primary rounded-pill fw-semibold px-4" onClick={() => handleClick()} >
                                    <svg className="icon icon-4x"><use href="#icon_plus"></use></svg>  Add
                                </button>
                            </div>

                            {open && (
                                <div id="dropdown">
                                    <ul id='ul'>
                                        <li onClick={() => { setValue('Achievements'); setopen(false) }} id='li'>Achievements</li>
                                        <li onClick={() => { setValue('Awards'); setopen(false) }} id='li'>Awards</li>
                                        <li onClick={() => { setValue('Press'); setopen(false) }} id='li'>Press</li>

                                    </ul>
                                </div>
                            )}

                        </div>




                    </div>
                    {value != undefined ? <ShowForm /> :

                        <Row>
                            <Col md='1'></Col>
                            <Col md='10'>
                                {achivements?.map((achivement, index) => (

                                    <div className="shadow p-3 mb-5 bg-white rounded">
                                        <div className="card-body p-3 p-sm-4">
                                            <div className="d-flex mb-3">



                                                <input className="form-check-input" type="checkbox" checked={checking[index]?.checked} name={achivement.key} id={achivement.key} value={achivement.key} onChange={e => categoryCheckboxFilterHandler(e, index)} />



                                                <div className="ps-3">
                                                    <h5>{achivement.type}</h5>
                                                    <h6>{achivement.title}</h6>
                                                    <p className="mb-1">{achivement.month} {achivement.year}</p>
                                                    <p>
                                                        {achivement.description}
                                                    </p>


                                                </div>
                                            </div>
                                            <button id='seelink' type="button" onClick={() => window.open(achivement.sourceUrl)} class="btn btn-link">See link to achievement</button>



                                        </div>
                                    </div>
                                ))}



                            </Col>


                        </Row>

                    }
                </div>



            }

        </>
    );
});
export default EditAchievements;